import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import { useSettingsState } from '../../../../context/SettingsContext';
import { Card } from '@/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';

function getServiceUrl(service) {
  if (service.externalId === 99999) {
    return '/dovanu-kuponai';
  }

  if (service.externalId === 99998) {
    return '/kompleksines-paslaugos';
  }

  return `/services/${service.categoryId}/${service.serviceTypeId}`;
}

const PanelLink = ({ label, href }) => (
  <a
    href={href}
    className="flex items-start w-full px-2 gap-1 text-primary text-base font-semibold hover:text-secondary"
  >
    <ArrowRight size={16} className="mt-1 w-4 h-4 shrink-0" />
    <span>{label}</span>
  </a>
);

export default function CategoryCard({
  displayCategoryId,
  title,
  services = [],
  defaultExpanded = false,
}) {
  const { theme } = useSettingsState();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (!defaultExpanded) {
      setExpanded(!isMobile);
    }
  }, [isMobile, defaultExpanded]);

  return (
    <Card className="p-0 sm:p-0 overflow-hidden h-full flex flex-col border-0">
      <Collapsible
        open={expanded || !isMobile}
        onOpenChange={setExpanded}
        className="flex flex-col flex-grow"
      >
        <CollapsibleTrigger className="w-full">
          <div className="flex items-center justify-between px-[25px] py-4 cursor-pointer">
            <h2 className="text-secondary font-semibold text-[22px] text-left">
              {title}
            </h2>
            {isMobile &&
              (expanded ? (
                <ChevronUp size={20} className="text-[#5180CA]" />
              ) : (
                <ChevronDown size={20} className="text-[#5180CA]" />
              ))}
          </div>
        </CollapsibleTrigger>

        <CollapsibleContent className="flex flex-col flex-grow h-full">
          <div className="flex flex-col justify-between flex-grow h-full gap-6">
            <div className="flex flex-col px-[25px] gap-1 flex-grow">
              {services.map((service) => (
                <PanelLink
                  key={service.serviceTypeId}
                  label={service.serviceTypeTitle}
                  href={getServiceUrl(service)}
                />
              ))}
            </div>
            <div
              className="w-full h-56 bg-cover bg-center"
              style={{
                backgroundImage: `url(${theme.categories[displayCategoryId]})`,
              }}
            />
          </div>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
}
